<template>
  <div class="container content-block" v-if="fetchingActivity">
    <div class="row mt-3 mb-3">
      <div class="col text-center">
        <div class="alert alert-info" role="alert">
          Activiteit ophalen.
        </div>
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Laden...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="activity == null">
    <NotFound></NotFound>
  </div>
  <div class="container" v-else>
    <div class="row">
      <!--      <router-link to="/activities"><i class="fas fa-chevron-left"></i> Terug</router-link>-->
      <ButtonBack></ButtonBack>
    </div>
    <div class="row content mt-3 mb-3">

      <div v-if="alreadyPlanned" class="col-lg-4">
        <div class="activityPlan">
          <BuddySelectButton :interactable="false" :buddy="activity.buddy"></BuddySelectButton>
          <div class="card mt-3 p-3">
            <h3 class="title ">Planning</h3>
            <div class="card flex-row mb-2">
              <p class="mt-2 mb-2 ml-3">
                <i class="fas fa-calendar icon-blue mr-3"></i>{{ formatDateMonthYear(activity.plannedDate) }}
              </p>
            </div>
            <div class="card flex-row mb-3">
              <p class="mt-2 mb-2 ml-3">
                <i class="fas fa-clock icon-blue mr-3"></i>{{ formatHourMinutes(activity.plannedDate) }}
              </p>
            </div>
            <v-button :button-text="'Bewerken'" :enabled="isEditable" v-on:clicked="editActivity"></v-button>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <QuestSummaryPanel :quest="activity.quest" :previous-activities="previousActivities"
                           :enable-plan-btn="false" :show-impulse-info="true"></QuestSummaryPanel>
      </div>
      <div class="" :class="alreadyPlanned? 'col-lg-4': 'col-lg-8'"
           v-if="activity.quest.type !== questTypeEnum.impulse">
        <QuestDetailPanel :quest="activity.quest"></QuestDetailPanel>
      </div>
    </div>
  </div>
</template>

<script>
import QuestSummaryPanel from "@/components/Quests/QuestSummaryPanel";
import QuestDetailPanel from "@/components/Quests/QuestDetailPanel";
import VButton from "@/components/UI/VButton";
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import BuddySelectButton from "@/components/Common/BuddySelectButton";
import DateFormatter from "@/mixins/DateFormatter";
import { ActivityApi, BuddyApi, QuestTypeEnum } from "sandpiper_api";
import log from "@/utils/logger";
import NotFound from "@/components/Common/NotFound";
import ButtonBack from "@/components/UI/ButtonBack";

export default {
  name: "Activity",
  components: { QuestSummaryPanel, QuestDetailPanel, VButton, BuddySelectButton, NotFound, ButtonBack },
  mixins: [ QuestTypeHelper, DateFormatter ],
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      activityId: null,
      fetchingActivity: false,
      activity: null,
      alreadyPlanned: true,
      fetchingSameQuestActivities: false,
      // Activities with the same quest planned at or before this activity's plannedDate (this will included the current activity as well)
      sameQuestActivities: [],

      questTypeEnum: new QuestTypeEnum()
    }
  },
  computed: {
    previousActivities()
    {
      return this.sameQuestActivities.filter(a => a.id !== this.activity.id);
    },
    isEditable()
    {
      return this.activity?.startedDate === null && this.activity?.completionDate === null;
    }
  },
  methods: {
    editActivity()
    {
      this.$router.push({ name: 'edit-planned-activity', params: { activityId: this.$route.params.id } });
    },
    fetchPathParams()
    {
      this.activityId = this.$route.params.id;
    },
    async fetchActivity()
    {
      try
      {
        this.fetchingActivity = true;
        const response = await this.doApiRequest(() => new ActivityApi().getActivity(this.activityId));

        log.info("Fetch activity response: %o", response);
        this.activity = response;

        if (this.activity.cancelledDate !== null)
        {
          await this.$router.push({
            name: "quest-detailed",
            params: { id: this.activity.quest.id }
          });
        }
      }
      catch (e)
      {
        this.activity = null;
        // TODO - handle exception, return to quest list?
        // await this.$router.push({name: 'quests'});
      }
      finally
      {
        this.fetchingActivity = false;
      }
    },
    async fetchActivitiesWithSameQuest()
    {
      try
      {
        this.fetchingSameQuestActivities = true;
        this.sameQuestActivities = [];
        const response = await this.doApiRequest(() => new BuddyApi().getBuddyActivities(this.activity.buddy.id, {
          beginDate: null,
          endDate: this.activity.plannedDate,
          questId: this.activity.quest.id
        }));

        log.info("Fetch previous activities response: %o", response);
        this.sameQuestActivities = response;
      }
      catch (e)
      {
        // TODO - handle exception
        // await this.$router.push({name: 'quests'});
      }
      finally
      {
        this.fetchingSameQuestActivities = false;
      }
    },
    async fetchActivityInfo()
    {
      await this.fetchActivity();
      await this.fetchActivitiesWithSameQuest();
    }
  },
  created()
  {
    this.fetchPathParams();
    this.fetchActivityInfo();
  }
}
</script>

<style lang="scss" scoped>
.content
{
  margin: 1rem 0;

  @media screen and (max-width: $large)
  {
    margin: 0 0;

    .content-col
    {
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.planned
{
  background-color: $activity-orange;
}

.icon-blue
{
  color: $primary-blue;
}

.icon-orange
{
  color: $activity-orange;
}

.header
{
  color: $font-light;

  font-weight: 500;
  font-size: 1.25rem;

  padding: 0 25px;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.properties
{
  padding: 25px 0px;
}

.property-list
{
  li
  {
    margin-bottom: 1rem;
  }

  .tag
  {
    margin-bottom: 0;
  }
}

.btn
{
  margin-bottom: 1rem;
}

.a
{
  display: flex;
  flex-direction: row;

  font-size: 0.875rem;

  .left
  {
    flex: 1;
    text-align: left;
  }

  .right
  {
    flex: 1;
    text-align: right;
  }
}

.title
{
  font-size: 1.25rem;
  font-weight: 500;
}

.article-title
{
  padding-bottom: 1rem;
}

.image
{
  img
  {
    width: 100%;
    border-radius: 5px;
  }

}

.document-container
{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-auto-rows: 50px;

  grid-gap: 10px 25px;
}
</style>